export enum ActionTypes {
    RESET = "RESET",
    HANDLEERROR = "HANDLEERROR",
}
